module.exports = "https://deal-img.imgix.net/consumer/modern/edge.b9ab84ae.png";